import '@/styles/normalize.css';
import '@/styles/index.less';
import 'element-ui/lib/theme-chalk/index.css';
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueLocalstorage from 'vue-localstorage';
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/ko';
import axios from 'axios';
import { sync } from 'vuex-router-sync';
import Moment from 'moment';
import App from './App';
import router from './router';
import store from './store';
import MyPagination from './plugins/my-pagination';

Vue.config.productionTip = false;

Vue.use(ElementUI, { locale });
Vue.use(VueLocalstorage);
Vue.use(Moment);
Vue.use(MyPagination);

if (Vue.localStorage.get('admin-token')) {
  axios.defaults.headers.common.Authorization = `Bearer ${Vue.localStorage.get('admin-token')}`;
} else if (Vue.localStorage.get('token')) {
  axios.defaults.headers.common.Authorization = `Bearer ${Vue.localStorage.get('token')}`;
}
// axios.defaults.baseURL = 'http://192.168.1.168:8080';
axios.defaults.baseURL = 'https://api.hanyac.co.kr';
// axios.defaults.baseURL = 'http://127.0.0.1:8081';

Vue.prototype.$http = axios;

const r = router(store, Vue.prototype.$http);
sync(store, r);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router: r,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js